// extracted by mini-css-extract-plugin
export default {"fontdiv":"MultiplechipSelect_fontdiv__1Q0Rg"};